<template>
  <div class="property">
      <div class="property-name">{{ name }}</div>
      <div class="property-value">{{ value }}</div>
  </div>
</template>

<script>
export default {
  name: 'Property',
  props: {
    name: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">

  .property {
    padding: 0 23px;
    display: flex;
    flex-direction: column;


    .property-name {
      font-family: SimplerPro;
      font-size: 14px;
    }

    .property-value {
      font-family: GretaSans;
      font-size: 20px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/responsive-pages/authenticated/navigation-pages/account-settings/Property.vue